import { USER_ROLES } from 'types'
import { USER_DRIVER_TYPES } from 'apps/user/types/user'
import { capitalize } from 'utils/capitalize'

export const DRIVER_TYPES_DISPLAY = {
  [USER_DRIVER_TYPES.driver]: 'Driver',
  [USER_DRIVER_TYPES.ownerOperator]: 'Owner operator',
}

export const userTypeOptions = Object.values(USER_DRIVER_TYPES).map((type: USER_DRIVER_TYPES) => ({
  value: type,
  label: DRIVER_TYPES_DISPLAY[type],
}))

export const userRoleOptions = Object.values(USER_ROLES).map((role: string) => ({
  value: role,
  label: capitalize(role),
}))
